<script setup lang="ts">
import DropdownLink from "@/stories/buttons/DropdownButton/DropdownLink.vue";
import Line from "@/stories/layout/Line/Line.vue";
import type { IOption } from "@/interfaces";
import type { PrimitiveModel } from "@/types";

interface Props {
  item?: IOption;
  intervalValue?: PrimitiveModel;
  isRadio?: boolean;
  autoClose?: boolean;
  customClass?: string;
}

withDefaults(defineProps<Props>(), {
  isRadio: false,
  autoClose: true,
});

defineEmits<{ click: [] }>();
</script>

<template>
  <DropdownLink
    v-if="item !== null"
    :is-active="intervalValue == item?.value"
    :radio="isRadio"
    :svg="item?.svg"
    :svgColor="item?.svgColor"
    :svgClass="item?.svgClass"
    :iconRight="item?.iconRight"
    :iconRightClass="item?.iconRightClass"
    :iconRightSize="item?.iconRightSize"
    :autoClose="autoClose"
    :customClass="customClass"
    @click="$emit('click')"
  >
    <template #left-icon>
      <slot name="left-icon"></slot>
    </template>
    <template #right-icon>
      <slot name="right-icon"></slot>
    </template>
    <span class="truncate">{{ item?.title }}</span>
  </DropdownLink>
  <Line v-if="item === null" padding="sm" />
</template>
